var map = {
	"./003_Wooden Bucket.jpg": 3880,
	"./005_Woden Barrel.jpg": 8320,
	"./010_Wooden Crate.jpg": 3656,
	"./015_Wooden Signs.jpg": 6860,
	"./020_Wooden Post.jpg": 8174,
	"./025_Wooden Cart.jpg": 1954,
	"./030_Suspension Bridge.jpg": 3258,
	"./035_Lounge Chair.jpg": 9329,
	"./036_Red Mushroom.jpg": 3207,
	"./037_Brown Mushroom.jpg": 6482,
	"./040_Oak Tree.jpg": 6750,
	"./045_Birch Tree.jpg": 7271,
	"./050_Pine Tree.jpg": 7104,
	"./055_Willow Tree.jpg": 3664,
	"./060_Simple Oak Tree.jpg": 8911,
	"./065_Cabbage Palm.jpg": 229,
	"./070_Coconut Palm.jpg": 4685,
	"./075_Coconut Palm.jpg": 7084,
	"./080_Daisy.jpg": 9748,
	"./085_Monstera Shrub.jpg": 6529,
	"./090_Cat Palm.jpg": 6065,
	"./095_SkyBlossom.jpg": 3595,
	"./Ancient Oak.jpg": 5660,
	"./Axe.jpg": 5425,
	"./BlackSmith.jpg": 6895,
	"./Bob.jpg": 1440,
	"./Brown Mushrooms.jpg": 6129,
	"./Child.jpg": 5902,
	"./City Center.jpg": 92,
	"./CityIsland.jpg": 1620,
	"./Dead God Island.jpg": 3370,
	"./Lobue.jpg": 522,
	"./Middle Aged Man.jpg": 8625,
	"./Modular Stone House Blocks.jpg": 5321,
	"./Modular Wooden House Blocks.jpg": 2043,
	"./Modular Wooden Structers.jpg": 1712,
	"./Oak Trees.jpg": 1406,
	"./Old Lady.jpg": 8689,
	"./Palm Tree.jpg": 9854,
	"./Potion Shop.jpg": 3509,
	"./Raft.jpg": 715,
	"./Red Mushrooms.jpg": 1634,
	"./Slide.jpg": 5975,
	"./Stone House.jpg": 8923,
	"./Stone Tall House.jpg": 2844,
	"./Wooden Crate Simple.jpg": 9522,
	"./Wooden Hay Stack.jpg": 6831,
	"./Wooden Ship.jpg": 6160,
	"./WoodenCottage.jpg": 5589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7965;